<template>
    <div>
        <div class="page page-team d-flex" id="team">
            <page-header class="top team-header"/>
            <side-nav/>
            <div class="row align-items-left w-100 no-gutters">
                <div class="team-top">
                    <div class="row align-items-top justify-content-md-start justify-content-center text-left d-flex team-list">
                        <div v-for="member in team" class="card-team text-left">
                            <p class="name liviomono">{{ member.name }}</p>
                            <p class="role">{{ member.role }}</p>
                            <p class="subtext">{{ member.subtext }}</p>
                        </div>
                    </div>
                </div>
                <div class="w-100"></div>
                <div class="offset-1 col-10">
                    <div class="row align-items-bottom justify-content-between text-center d-flex w-100 team">
                        <img class="livio-illustration" src="../../static/images/1x/skyline.png" srcset="../../static/images/2x/skyline@2x.png 2x, ../../static/images/3x/skyline@3x.png 3x" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>

import Header from './shared/Header.vue'
import Footer from './shared/Footer.vue'
import SideNav from './shared/SideNav.vue'
export default {
    data () {
        return {
            "team": [
                {
                    "name": "Paul Elsila",
                    "role": "Chief Executive Officer",
                    "subtext": null,
                },
                {
                    "name": "Joey Grover",
                    "role": "Chief Technology Officer",
                    "subtext": null,
                },
                {
                    "name": "Chris Rokita",
                    "role": "Software Engineer",
                    "subtext": "Web",
                },
                {
                    "name": "Jacob Keeler",
                    "role": "Software Engineer",
                    "subtext": "Embedded",
                },
                {
                    "name": "Theresa Lech",
                    "role": "Program Manager",
                    "subtext": null,
                },
                {
                    "name": "Jordyn Mackool",
                    "role": "Program Manager",
                    "subtext": null,
                },
                {
                    "name": "Shobhit Adlakha",
                    "role": "Software Engineer",
                    "subtext": "Embedded",
                },
                {
                    "name": "Nick Reno",
                    "role": "Software Engineer",
                    "subtext": "Web",
                },
                {
                    "name": "Julian Kast",
                    "role": "Software Engineer",
                    "subtext": "Android",
                },
                {
                    "name": "Francois Elias",
                    "role": "Software Engineer",
                    "subtext": "iOS",
                },
                {
                    "name": "Chloe Matthews",
                    "role": "Software Engineer",
                    "subtext": "Android"
                },
                {
                    "name": "Justin Beharry",
                    "role": "Software Engineer",
                    "subtext": "iOS"
                },
                {
                    "name": "Derrick Portis",
                    "role": "Software Engineer",
                    "subtext": "android"
                },
                {
                    "name": "Jacob Rau",
                    "role": "Software Engineer",
                    "subtext": "iOS"
                },
                {
                    "name": "Rickie Sanders",
                    "role": "quality assurance",
                    "subtext": null
                },
                {
                    "name": "Surya Sagiraju",
                    "role": "Software Engineer",
                    "subtext": "android"
                },
                {
                    "name": "Ty Strayer",
                    "role": "Software Engineer",
                    "subtext": "iOS"
                },
                {
                    "name": "Brandon Garrison",
                    "role": "Software Engineer",
                    "subtext": "Android"
                }
            ]
        }
    },
    components: {
        "page-footer": Footer,
        "page-header": Header,
        "side-nav": SideNav,
    }
}
</script>



// WEBPACK FOOTER //
// src/components/Team.vue